import { ReactElement } from "react";

import { type Machine } from "_/data/machines";
import { MachineTemperatureDisplay } from "_/components/machine-temperature-display";

import { TemperatureChart } from "./chart";
import * as S from "./styled";

type MachineTemperatureProps = {
  machine: Machine;
  maxTemp?: number;
  timeWindow?: number;
};

export const MachineTemperature = ({
  machine,
  maxTemp,
  timeWindow,
}: MachineTemperatureProps): ReactElement => (
  <S.MachineTemperatureContainer>
    <MachineTemperatureDisplay machine={machine} view="wide" />
    <S.ChartWidget>
      <S.Wrapper>
        <TemperatureChart
          machine={machine}
          maxTemp={maxTemp}
          timeWindow={timeWindow}
        />
      </S.Wrapper>
    </S.ChartWidget>
  </S.MachineTemperatureContainer>
);
